export default __webpack_public_path__ + "static/how-do-caravans-and-campervans-compare-f1cbbd871971c1a012b74d8a0a99c00e.jpg";